import React, { useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Button,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
  makeStyles,
  Switch
} from '@material-ui/core';
import {
  AlertCircle as AlertCircleIcon,
  BarChart as BarChartIcon,
  Lock as LockIcon,
  Settings as SettingsIcon,
  ShoppingBag as ShoppingBagIcon,
  User as UserIcon,
  UserPlus as UserPlusIcon,
  Users as UsersIcon
} from 'react-feather';
import NavItem from './NavItem';
import {
  API_BASE_URL,
  WHITE_LABEL_TEAM_ID
} from '../../../views/data/environment';
import CreditCardOutlinedIcon from '@material-ui/icons/CreditCardOutlined';
import Axios from 'axios';
import yotesLogo from '../../../images/logo.png';
import AccessAlarmRoundedIcon from '@material-ui/icons/AccessAlarmRounded';

const user = {
  avatar: '/static/images/avatars/ss_logo.png',
  name: 'Credit Bank Portal',
  teamId: `Team ID #${WHITE_LABEL_TEAM_ID}`
};

const items = [
  // {
  //   href: '/portal/dashboard',
  //   icon: BarChartIcon,
  //   title: 'Dashboard'
  // },
  {
    href: '/portal/customers',
    icon: UsersIcon,
    title: 'Customers'
  },
  {
    href: '/portal/transactions',
    icon: ShoppingBagIcon,
    title: 'Transactions'
  },
  {
    href: '/portal/events',
    icon: UserIcon,
    title: 'Event Setup'
  },
  {
    href: '/portal/addcredit',
    icon: CreditCardOutlinedIcon,
    title: 'Add credit'
  },
  {
    href: '/portal/eventreminders',
    icon: AccessAlarmRoundedIcon,
    title: 'Event Reminders'
  }
  // {
  //   href: '/app/account',
  //   icon: UserIcon,
  //   title: 'Account'
  // },
  // {
  //   href: '/app/settings',
  //   icon: SettingsIcon,
  //   title: 'Inventory Setup'
  // },
  // {
  //   href: '/app/settings',
  //   icon: SettingsIcon,
  //   title: 'Settings'
  // },
  // {
  //   href: '/login',
  //   icon: LockIcon,
  //   title: 'Login'
  // },
  // {
  //   href: '/register',
  //   icon: UserPlusIcon,
  //   title: 'Register'
  // },
  // {
  //   href: '/404',
  //   icon: AlertCircleIcon,
  //   title: 'Error'
  // }
];

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  }
}));

const NavBar = ({ onMobileClose, openMobile }) => {
  const classes = useStyles();
  const location = useLocation();
  const [isPortalOpen, setIsPortalOpen] = React.useState(true);
  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    Axios.post(`${API_BASE_URL}/configuration/enabled`).then(res => {
      setIsPortalOpen(res.data.isPortalOpen);
    });
  }, [location.pathname]);

  const updatePortal = isOpen => {
    Axios.post(`${API_BASE_URL}/configuration/enabled/update`, {
      isPortalOpen: isOpen
    }).then(res => {
      setIsPortalOpen(isOpen);
    });
  };

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <Box alignItems="center" display="flex" flexDirection="column" p={2}>
        <Avatar
          className={classes.avatar}
          component={RouterLink}
          src={yotesLogo}
        />
        <Typography className={classes.name} color="textPrimary" variant="h5">
          {user.name}
        </Typography>
        <Typography color="textSecondary" variant="body2">
          {user.teamId}
        </Typography>
        <Switch
          checked={isPortalOpen}
          onChange={(e, isChecked) => {
            updatePortal(isChecked);
          }}
        />
        {isPortalOpen && (
          <Typography color="secondary">ACCEPTING REDEMPTIONS</Typography>
        )}
        {!isPortalOpen && <Typography color="secondary">CLOSED</Typography>}
      </Box>
      <Divider />
      <Box p={2}>
        <List>
          {items.map(item => (
            <NavItem
              href={item.href}
              key={item.title}
              title={item.title}
              icon={item.icon}
            />
          ))}
        </List>
      </Box>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

NavBar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false
};

export default NavBar;
